export class EducationIdRequest{
    educationId: number;

    constructor(educationId: number){
        this.educationId = educationId;
    }
}